export const locationEndpointConfig = {
  baseUrl: "api/v1/merchants",
  locationData: (): string => `${locationEndpointConfig.baseUrl}/stations`,
  updateLocation: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}`,
  getLocation: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}`,
  closeLocation: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}/close`,
  networkProvider: (country: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/terminals/country/${country}`,
  temporarilyCloseLocation: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}/temporarily-close`,
  adjustAvailability: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}/adjust-availability`,
  adjustClosureDate: (stationId: string): string =>
    `${locationEndpointConfig.baseUrl}/stations/${stationId}/adjust-closure-date`,
};
